import React from 'react';

export default React.createClass({
	render() {
		return (
			<div className={'Alert Alert--'+this.props.type}>{this.props.children}</div>
		);
	}
});